module.exports = __webpack_public_path__ + "edera_logo.png?dd46e3562134d683c21c5e2fcc978b21";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edera_logo.png
// module id = 21
// module chunks = 0